var map = {
	"./1 - Copy.png": 5461,
	"./1.png": 9317,
	"./10.png": 337,
	"./10CC.png": 1847,
	"./10DD.png": 769,
	"./10HH.png": 5761,
	"./10SS.png": 7063,
	"./11.png": 2472,
	"./12.png": 7747,
	"./13.png": 170,
	"./2.png": 2590,
	"./2CC.png": 3340,
	"./2DD.png": 2414,
	"./2HH.png": 6278,
	"./2SS.png": 8524,
	"./3.png": 8375,
	"./3CC.png": 1293,
	"./3DD.png": 9295,
	"./3HH.png": 5575,
	"./3SS.png": 4285,
	"./4.png": 8760,
	"./4CC.png": 1342,
	"./4DD.png": 3400,
	"./4HH.png": 656,
	"./4SS.png": 7054,
	"./5.png": 7153,
	"./5CC.png": 3031,
	"./5DD.png": 2481,
	"./5HH.png": 7473,
	"./5SS.png": 2695,
	"./6.png": 906,
	"./6CC.png": 2744,
	"./6DD.png": 6810,
	"./6HH.png": 4066,
	"./6SS.png": 152,
	"./7.png": 739,
	"./7CC.png": 5161,
	"./7DD.png": 5035,
	"./7HH.png": 643,
	"./7SS.png": 7241,
	"./8.png": 6900,
	"./8CC.png": 5898,
	"./8DD.png": 5364,
	"./8HH.png": 3708,
	"./8SS.png": 8810,
	"./9.png": 141,
	"./9CC.png": 3459,
	"./9DD.png": 9181,
	"./9HH.png": 2061,
	"./9SS.png": 2995,
	"./A.png": 3429,
	"./ACC.png": 683,
	"./ADD.png": 4805,
	"./AHH.png": 1221,
	"./ASS.png": 4667,
	"./J.png": 2566,
	"./JCC.png": 5684,
	"./JDD.png": 7494,
	"./JHH.png": 8654,
	"./JSS.png": 2916,
	"./K.png": 4111,
	"./KCC.png": 9349,
	"./KDD.png": 5863,
	"./KHH.png": 2031,
	"./KSS.png": 9813,
	"./Q.png": 3509,
	"./QCC.png": 6395,
	"./QDD.png": 6197,
	"./QHH.png": 2085,
	"./QSS.png": 5387,
	"./club.png": 5358,
	"./diamond.png": 4372,
	"./heart.png": 3076,
	"./spade.png": 8951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7141;